import React from 'react'
import { Flex } from 'antd'
import { Color } from '../../../Common/Color'
import Solution from './Solution'
import News from './News'
import MedicalDevices from './MedicalDevices'
import Consultation from './Consultation'
import Goal from './Goal'

export default function TabletHomePage ({ news }) {
  return (
    <Flex vertical gap='1em' style={{ backgroundColor: Color.white }}>
      <News news={news} />
      <Goal />
      <Solution />
      <MedicalDevices />
      <Consultation />
    </Flex>
  )
}
